import React from 'react';
import { Box, Paper } from '@mui/material';
import FeatureSearch, { FeatureIndexItem } from '../FeatureSearch';

interface TopSearchBarProps {
    featureIndex: FeatureIndexItem[];
    onFeatureSelect: (feature: FeatureIndexItem) => void;
}

const TopSearchBar: React.FC<TopSearchBarProps> = ({ featureIndex, onFeatureSelect }) => {
    return (
        <Box sx={{
            position: 'absolute',
            top: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1000,
            width: '90%',
            maxWidth: '600px',
        }}>
            <Paper
                elevation={4}
                sx={{
                    borderRadius: '24px',
                    overflow: 'hidden',
                    backgroundColor: 'rgba(24, 29, 38, 0.95)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    p: 0.5
                }}
            >
                <FeatureSearch
                    featureIndex={featureIndex}
                    onSelect={onFeatureSelect}
                    alwaysOpen={true}
                    headerStyle={{ width: '100%' }}
                />
            </Paper>
        </Box>
    );
};

export default TopSearchBar;
